export default __webpack_public_path__ + "static/media/logo_compas_30.5cc3ebb2.png";